'use client'

import React from 'react'
import { ApolloWrapper, getMakeClient } from '@phoenix-web/ux-gql/ssr'
import { GQL_PROXY_URI, GQL_PUBLIC_URI, GQL_URI } from '@/constants'

interface GraphqlLayout {
  children: React.ReactNode
}

const clientOptions = {
  clientName: 'terrace',
  uri: `${GQL_URI}`,
  uriPublic: `${GQL_PUBLIC_URI}`,
  uriProxy: `${GQL_PROXY_URI}`,
  getHeaders: async () => {
    return {}
  },
}

const client = getMakeClient(clientOptions)

export default function GraphqlLayout({ children }: GraphqlLayout) {
  return <ApolloWrapper client={client}>{children}</ApolloWrapper>
}
